'use strict';

require('../../styles/templates/product.scss');

var _productImage = require('../components/product-image');

var _productFinish = require('../components/product-finish');

var _productGlossary = require('../components/product-glossary');

var _productPrintTypes = require('../components/product-print-types');

var _imdbDetails = require('../components/imdbDetails');

// Import CSS
document.addEventListener('DOMContentLoaded', function () {
  (0, _productImage.init)();
  (0, _productFinish.init)();
  (0, _productGlossary.init)();
  (0, _imdbDetails.init)();
});

//Reinit when theme section settings have been updated


// Components
$(document).on('shopify:section:load', function () {
  (0, _productImage.init)();
  (0, _productFinish.init)();
  (0, _productGlossary.init)();
  (0, _imdbDetails.init)();
});